import { render, staticRenderFns } from "./AufgabenVerwaltungSearchBar.vue?vue&type=template&id=3851df69&scoped=true"
import script from "./AufgabenVerwaltungSearchBar.vue?vue&type=script&lang=js"
export * from "./AufgabenVerwaltungSearchBar.vue?vue&type=script&lang=js"
import style0 from "./AufgabenVerwaltungSearchBar.vue?vue&type=style&index=0&id=3851df69&prod&scoped=true&lang=css"
import style1 from "./AufgabenVerwaltungSearchBar.vue?vue&type=style&index=1&id=3851df69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851df69",
  null
  
)

export default component.exports